<div class="PGManageNotifications">
    @if (isSavingNotificationSettings) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-user-menu.modal-manage-notifications-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="dismissModal()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        @if (manageNotificationData) {
            @if (webPushService.isSupported()) {
                <div class="mb-3 pb-3 border-bottom">
                    <label class="mb-2"><b>{{ 'pg-user-menu.modal-manage-notifications-webpush' | locTranslate }}</b></label>
                    <div class="d-flex align-items-center">
                        <app-pg-switch [small]="true" [readonly]="isTogglingWebPush" [ngModel]="webPushService.enabled" (ngModelChange)="setDeviceWebPushEnabled($event)"></app-pg-switch>
                        <label class="ps-2">{{ 'pg-user-menu.modal-manage-notifications-device-webpush' | locTranslate }}</label>
                    </div>
                </div>
            }

            <div class="mb-4">
                <div class="row">
                    <div class="col-6">
                        <label class="mb-2"><b>{{ 'pg-user-menu.modal-manage-notifications-channels' | locTranslate }}</b></label>
                        <app-pg-select [multi]="true" [useKeys]="true" [ngModel]="getChannelsValue()" (ngModelChange)="setChannelsValue($event)" [options]="notificationChannelOptions" display="oneLine"></app-pg-select>
                    </div>
                    <div class="col-6">
                        <label class="mb-2"><b>{{ 'pg-user-menu.modal-manage-notifications-digest-all' | locTranslate }}</b></label>
                        <app-pg-select [ngModel]="getDigestMinutes()" (ngModelChange)="setDigestMinutes($event)" [options]="notificationDigestOptions" display="oneLine" [required]="true"></app-pg-select>
                    </div>
                </div>
            </div>

            @if (showOtherRealmsSwitch) {
                <div class="mb-3">
                    <label class="mb-2"><b>{{ 'pg-user-menu.modal-manage-notifications-linked-areas' | locTranslate }}</b></label>
                    <div class="d-flex align-items-center">
                        <app-pg-switch [small]="true" [ngModel]="getOtherRealms()" (ngModelChange)="setOtherRealms($event)"></app-pg-switch>
                        <label class="ps-2">{{ 'pg-user-menu.modal-manage-notifications-other-realms' | locTranslate }}</label>
                    </div>
                </div>
            }

            <div class="mb-2">
                <label class="mb-2"><b>{{ 'pg-user-menu.modal-manage-notifications-content-types' | locTranslate }}</b></label>
                <app-pg-select [multi]="true" [useKeys]="true" [ngModel]="getTypesValue()" (ngModelChange)="setTypesValue($event)" [options]="notificationTypeOptions" display="multiLine"></app-pg-select>
            </div>

            <div class="mb-3 d-flex align-items-center">
                <app-pg-switch [small]="true" [ngModel]="getDigestUnifyProductTypes()" (ngModelChange)="setDigestUnifyProductTypes($event)"></app-pg-switch>
                <label class="ps-2">{{ 'pg-user-menu.modal-manage-notifications-digest-unify-product-types' | locTranslate }}</label>
            </div>

            <div class="mb-3">
                <div class="table-responsive">
                    <table class="table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>{{ 'pg-user-menu.modal-manage-notifications-event' | locTranslate }}</th>
                                <th class="text-center PGManageNotifications-ColEnabled">{{ 'pg-user-menu.modal-manage-notifications-enabled' | locTranslate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (eventKey of eventKeys; track eventKey) {
                                <tr>
                                    <td>{{ getEventLabel(eventKey) }}</td>
                                    <td class="text-center">
                                        <app-pg-switch [small]="true" [ngModel]="getEventEnabled(eventKey)" (ngModelChange)="setEventEnabled(eventKey, $event)"></app-pg-switch>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="mb-4">
                <div class="table-responsive">
                    <table class="table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>{{ 'pg-user-menu.modal-manage-notifications-event-digest' | locTranslate }}</th>
                                <th class="text-center PGManageNotifications-ColEnabled">{{ 'pg-user-menu.modal-manage-notifications-enabled' | locTranslate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (eventKey of eventKeysWithDigest; track eventKey) {
                                <tr>
                                    <td>{{ getEventLabel(eventKey) }}</td>
                                    <td class="text-center">
                                        <app-pg-switch [small]="true" [ngModel]="getEventEnabled(eventKey)" (ngModelChange)="setEventEnabled(eventKey, $event)"></app-pg-switch>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" [disabled]="isSavingNotificationSettings" (click)="dismissModal()">
            <i class="fa-regular fa-undo"></i><span>{{ 'pg-user-menu.modal-manage-notifications-button-cancel' | locTranslate }}</span>
        </button>
        <button class="btn btn-primary" [disabled]="isSavingNotificationSettings" (click)="doSave()">
            <i class="fa-regular fa-save"></i><span>{{ 'pg-user-menu.modal-manage-notifications-button-save' | locTranslate }}</span>
        </button>
    </div>
</div>
